import React, { useEffect, useState, useRef } from "react";
import Modal from 'react-modal';
import './AdminLeaveTable.css';
import { format, set } from 'date-fns';
import DatePicker from 'react-datepicker';
import { getApprovedLeaves, getLeaves, rejectLeave, updateLeavesApprove, getFilteredApprovedLeaves } from "../../../services/leaveService";
import { getAuditLog } from "../../../utils/calculateDaysInMonthUtils";
import { selectStyles } from "../../../assets/Styles/selectStyle";
import Select from 'react-select';
import { getDistrict, getStates } from "../../../services/monthlyAttendanceService";
import { capitalizeFirstLetter, isAlphabet, onlyDigits, validateMobile } from "../../../utils/validations";

const AdminLeaveTable = () => {
  const effectRan = useRef(false);
  const [state, setState] = useState(3);
  const [district, setDistrict] = useState(null);
  const [errors, setErrors] = useState({});
  const [designation, setDesignation] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [error, setError] = useState(null);
  const [approvedLeaves, setApprovedLeaves] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLeave, setCurrentLeave] = useState(null);
  const [remark, setRemark] = useState('');
  const [fromDate, setFromDate] = useState("");
  const dateInputRef = useRef(null);
  const [toDate, setToDate] = useState("");
  const employeeId = localStorage.getItem('employeeId');
  const employeeUniqueId = localStorage.getItem('employeeUniqueIdLogin');
  const role = localStorage.getItem('role');
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [loading, setLoading] = useState('');
  const [backuPersonName, setBackupPersonName] = useState("");
  const [backupPersonMobileNo, setBackupPersonMobileNo] = useState("");
  const [backupDetails, setBackupDetails] = useState({});
  const [isFocused, setIsFocused] = useState({
    state: false,
    district: false,
    designation: false,
    fromDate: false,
    employee: false,
    toDate: false,
    clients: false,
    project: false,
  });
  const fetchLeaves = async () => {
    // Check if we actually have the data before calling the API
    if (!employeeUniqueId || !role) {
      console.warn("Skipping fetchLeaves: employeeUniqueId or role is missing");
      return;
    }

    try {
      const data = await getLeaves(employeeUniqueId, role);
      setLeaveList(data);
    } catch (error) {
      setError("Error fetching leaves.");
      console.error("Error fetching leaves:", error);
    }
  };

  // const fetchApprovedLeaves = async () => {
  //   try {
  //     const data = await getApprovedLeaves(employeeId);
  //     setApprovedLeaves(data);
  //   } catch (err) {
  //     console.error('Error fetching approved leaves:', err);
  //   }
  // };

  useEffect(() => {
    fetchLeaves();
    // fetchApprovedLeaves();
  }, []);
  const handleBackupChange = (leaveId, field, value) => {
    setBackupDetails(prev => ({
      ...prev,
      [leaveId]: {
        ...prev[leaveId],
        [field]: value
      }
    }));
  };
  const handleStatusUpdate = async (leave, newStatus) => {
    const confirmMessage = `Are you sure you want to ${newStatus.toLowerCase()} this leave request?`;
    const isConfirmed = window.confirm(confirmMessage);

    if (!isConfirmed) return;

    if (newStatus === "Denied") {
      // Open modal for remark input
      setCurrentLeave(leave);
      setIsModalOpen(true);
      // fetchApprovedLeaves();
      // fetchLeaves();
      //getLeaves();
      return;
    }

    try {
      const backupInfo = backupDetails[leave.id] || {};
      const payload = {
        leaveId: leave.id,
        backupPersonName: backupInfo.name || null,
        backupPersonContactNumber: backupInfo.mobile || null,
        auditlog: getAuditLog(),
      };

      if (newStatus === "Approved") {
        await updateLeavesApprove(payload);
        const updatedLeave = { ...leave, status: newStatus };
        setLeaveList((prev) => prev.filter((l) => l.id !== leave.id));
        // setApprovedLeaves((prev) => {
        //   const exists = prev.find((l) => l.id === leave.id);
        //   if (exists) {
        //     return prev.map((l) => (l.id === leave.id ? updatedLeave : l));
        //   }
        //   return [...prev, updatedLeave];
        // });

        alert("Leave Updated Successfully");
        //fetchLeaves();
        // fetchApprovedLeaves();
        // getLeaves();
        fetchLeaves();
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.error || "An unknown error occurred.";
      setError(errorMessage);
      alert(errorMessage);
    }
  };

  const handleDenySubmit = async () => {
    if (!remark.trim()) {
      alert("Remark cannot be empty.");
      return;
    }

    try {
      const payload = {
        leaveId: currentLeave.id,
        auditlog: getAuditLog(),
        remark,
      };

      await rejectLeave(payload);

      setLeaveList((prevLeaves) =>
        prevLeaves.map((l) =>
          l.id === currentLeave.id ? { ...l, status: "Denied", remark } : l
        )
      );

      alert("Leave Denied Successfully");
      setIsModalOpen(false);
      setRemark('');
      //fetchLeaves();
      //fetchApprovedLeaves();
      //getLeaves();
      setCurrentLeave(null);
    } catch (error) {
      const errorMessage = error?.response?.data?.error || "An unknown error occurred.";
      setError(errorMessage);
      alert(errorMessage);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setRemark('');
    setCurrentLeave(null);
  };


  useEffect(() => {
    const fetchStates = async () => {
      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
        const data = await getStates();
        setStateOptions(
          data.map(item => ({
            value: item.id,
            label: capitalizeFirstLetter(item.stateName),
          }))
        );
      } catch (error) {
        console.error('Error fetching states:', error);
        setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
      }
    };
    if (!effectRan.current) {
      fetchStates();
    }
    return () => {
      effectRan.current = true;
    }
  }, []);


  // Fetch districts when state changes
  useEffect(() => {
    if (state) {
      const fetchDistricts = async () => {
        try {
          //const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
          const data = await getDistrict(state);
          setDistrictOptions(
            data.map(item => ({
              value: item.districtId,
              label: item.districtName,
            }))
          );
        } catch (error) {
          console.error('Error fetching districts:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
        }
      };
      // if (!effectRan.current) {
      fetchDistricts();
      // }
      // return () => {
      //     effectRan.current = true;
      // }

    } else {
      setDistrictOptions([]);
      setDistrict(null);
    }
  }, [state]);


  const statusOptions = [
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' } // Or 'Denied' based on your backend naming
  ];
  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption ? selectedOption.value : null;
    switch (field) {
      case 'state':
        setState(value);
        setDistrict(null);
        break;
      case 'district':
        setDistrict(value);
        // setProject(null); // ✅ Clear project when district changes
        break;
      case 'status': // Add this
        setSelectedStatus(value);
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [field]: null }));
  };
  const handleFilterSubmit = async () => {
    // Validation: Required fields
    if (!fromDate || !toDate || !state || !selectedStatus) {
      alert("Please select State, From Date,  To Date and Status.");
      return;
    }

    setLoading(true); // Assuming you have a loading state
    try {
      const filters = {
        employeeId: localStorage.getItem('employeeId'),
        stateId: state,
        fromDate: fromDate, // Already formatted as YYYY-MM-DD in your DatePicker logic
        toDate: toDate,
        status: selectedStatus, // Optional
        districtId: district    // Optional
      };

      const data = await getFilteredApprovedLeaves(filters);
      setApprovedLeaves(data);

      if (data.length === 0) {
        alert("No records found for the selected filters.");
      }
    } catch (err) {
      alert("Failed to fetch filtered records.");
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilters = () => {
    setFromDate("");
    setToDate("");
    setDistrict(null);
    setSelectedStatus(null);
    setApprovedLeaves([]);
    //fetchApprovedLeaves(); // Reload default list
  };
  return (
    <React.Fragment>
      <div className="adminleavetable-main">
        <h3 className="adminleavetable-heading">Leave Request List</h3>
        <div className="adminleave-table">
          <table className="adminleavemanagement-table">
            <thead>
              <tr>
                {/* <th>S.no</th>
                <th>Emp Id</th> */}
                <th>District</th>
                <th>Designation</th>
                <th>Employee Name</th>
                <th>Contact Number</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>No of Days</th>
                <th>Available Leaves</th>
                <th>Leave Type</th>
                <th>Reason</th>
                <th>Backup Person Name</th>
                <th>Backup Person Mobile No</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody className="border-color-for-td">
              {leaveList.length > 0 ? (
                leaveList.map((leave, index) => {
                  // Define currentBackup here for each row
                  const currentBackup = backupDetails[leave.id] || { name: '', mobile: '' };

                  return (
                    <tr key={leave.id || index}> {/* Use leave.id as key instead of index for better practice */}
                      <td>{leave.districtName}</td>
                      <td>{leave.designation}</td>
                      <td>{leave.employeeName}</td>
                      <td>{leave.contactNumber}</td>
                      <td className=" text-nowrap">{format(new Date(leave.fromDate), 'dd-MM-yyyy')}</td>
                      <td className=" text-nowrap">{format(new Date(leave.toDate), 'dd-MM-yyyy')}</td>
                      <td>{leave.daysApplied}</td>
                      <td>{leave.availableLeaves}</td>
                      <td>{leave.type}</td>
                      <td>{leave.reason}</td>
                      <td>
                        <input
                          type="text"
                          value={currentBackup.name}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (isAlphabet(value) || value === '') { // Allow empty string
                              handleBackupChange(leave.id, 'name', value);
                            }
                          }}
                          placeholder="Backup Person Name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={currentBackup.mobile}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (onlyDigits(value) || value === '') { // Allow empty string
                              handleBackupChange(leave.id, 'mobile', value);
                            }
                          }}
                          onBlur={() => {
                            const mobile = currentBackup.mobile;
                            if (mobile && !validateMobile(mobile)) {
                              alert("Enter a valid 10-digit Indian mobile number starting with 6-9");
                            }
                          }}
                          placeholder="Backup Mobile Number"
                        />
                      </td>
                      <td className="d-flex m-4 align-items-center justify-content-center border-0 gap-2">
                        <>
                          <button
                            className="button-approve"
                            onClick={() => handleStatusUpdate(leave, 'Approved')}
                          >
                            Approve
                          </button>
                          <button
                            className="button-deny"
                            onClick={() => handleStatusUpdate(leave, 'Denied')}
                          >
                            Deny
                          </button>
                        </>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="14" style={{ textAlign: 'center' }}>No leave requests found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {error && <div className="error-message">{error}</div>}
      </div>

      <div>



      </div>


      <div className="adminleavetable-main">
        <h3 className="adminleavetable-heading">Approved/Rejected Leaves</h3>


        <div className="leaves-dropdwon-border">

          <div className="leave-approval-maincontainer">
            <div className="leave-approval-container-part">
              <div className={`leave-approval-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                <Select
                  name="state"
                  options={stateOptions}
                  value={stateOptions.find(opt => opt.value === state) || null}
                  onChange={option => handleInputChange(option, 'state')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label><span className="required">*</span>State</label>
                {errors.state && <div className="error-message">{errors.state}</div>}
              </div>
            </div>
            <div className="leave-approval-container-part">
              <div className={`leave-approval-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                <Select
                  name="district"
                  options={districtOptions}
                  value={districtOptions.find(opt => opt.value === district) || null}
                  onChange={option => handleInputChange(option, 'district')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>District</label>
                {errors.district && <div className="error-message">{errors.district}</div>}
              </div>
            </div>
          </div>

          <div className="leave-approval-maincontainer">
            {/* From Date */}
            <div className="approval-container-part">
              <div className={`approval-label-container-2 ${isFocused.fromDate || fromDate ? 'float-label' : ''}`}>
                <DatePicker
                  selected={fromDate ? new Date(fromDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const localDate = new Date(date);
                      localDate.setHours(0, 0, 0, 0);
                      const formatted = localDate.toLocaleDateString("en-CA");
                      setFromDate(formatted);
                    } else {
                      setFromDate("");
                    }
                  }}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="dd-MM-yyyy"
                  className="did-floating-input"
                  onFocus={() => setIsFocused(prev => ({ ...prev, fromDate: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, fromDate: false }))}
                  ref={dateInputRef}
                  // maxDate={toDate ? new Date(toDate) : null} // prevents selecting after "To"
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={35}
                />
                <label>
                  <span className="required">*</span>From Date (DD-MM-YYYY)
                </label>
                {errors.fromDate && <div className="error-message">{errors.fromDate}</div>}
              </div>
            </div>

            {/* To Date */}
            <div className="approval-container-part">
              <div className={`approval-label-container-2 ${isFocused.toDate || toDate ? 'float-label' : ''}`}>
                <DatePicker
                  selected={toDate ? new Date(toDate) : null}
                  onChange={(date) => {
                    if (date) {
                      const localDate = new Date(date);
                      localDate.setHours(0, 0, 0, 0);
                      const formatted = localDate.toLocaleDateString("en-CA");
                      setToDate(formatted);
                    } else {
                      setToDate("");
                    }
                  }}
                  dateFormat="dd-MM-yyyy"
                  placeholderText="dd-MM-yyyy"
                  className="did-floating-input"
                  onFocus={() => setIsFocused(prev => ({ ...prev, toDate: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, toDate: false }))}
                  ref={dateInputRef}
                  // minDate={fromDate ? new Date(fromDate) : null} // prevents selecting before "From"
                  // maxDate={new Date()}
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={35}
                />
                <label>
                  <span className="required">*</span>To Date (DD-MM-YYYY)
                </label>
                {errors.toDate && <div className="error-message">{errors.toDate}</div>}
              </div>
            </div>
          </div>
          <div className="leave-approval-maincontainer">
            <div className="leave-approval-container-part">
              <div className={`leave-approval-floating-label-container ${isFocused.status || selectedStatus ? 'float-label' : ''}`}>
                <Select
                  name="status"
                  options={statusOptions}
                  value={statusOptions.find(opt => opt.value === selectedStatus) || null}
                  onChange={option => handleInputChange(option, 'status')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, status: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, status: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label><span className="required">*</span>Status</label>
              </div>
            </div>

            <div className="leave-approval-container-part">
              <div className="filter-button-group">
                <button
                  className="btn-get"
                  onClick={handleFilterSubmit}
                  disabled={loading}
                >
                  {"Get"}
                </button>
                <button
                  className="btn-clear"
                  onClick={handleClearFilters}
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

        </div>
        {approvedLeaves.length > 0 && (
          <div className="adminleave-table">
            <table className="adminleavemanagement-table">
              <thead>
                <tr>
                  {/* <th>ID</th>
                  <th>Employee ID</th> */}
                  <th>District</th>
                  <th>Designation</th>
                  <th>Employee Name</th>
                  <th>Contact Number</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>No of Days</th>
                  <th>Leave Type</th>
                  <th>Reason</th>
                  <th>Backup Person</th>
                  <th>Backup Person Mobile No</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {approvedLeaves.map((leave, index) => (
                  <tr key={index}>
                    {/* <td>{index+1}</td>
                    <td>{leave.employeeId}</td> */}
                    <td>{leave.districtName}</td>
                    <td>{leave.designation}</td>
                    <td>{leave.employeeName}</td>
                    <td>{leave.contactNumber}</td>
                    <td className=" text-nowrap">{format(leave.fromDate, 'dd-MM-yyyy')}</td>
                    <td className=" text-nowrap">{format(leave.toDate, 'dd-MM-yyyy')}</td>
                    <td>{leave.daysApplied}</td>
                    <td>{leave.type}</td>
                    <td>{leave.reason}</td>
                    <td>{leave.backupPersonName||"-"}</td>
                    <td>{leave.backupPersonContactNumber||"-"}</td>
                    <td>{leave.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

      </div>



      {/* Modal for entering deny remark */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal-content"
        overlayClassName="modal-overlay"
        contentLabel="Deny Leave Remark"
      >
        <h2 className="modal-heading">Deny Leave Request</h2>
        <p>Please enter the reason for denying this leave request:</p>
        <textarea
          className="modal-textarea"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder="Enter remark"
          rows="4"
        />
        <div className="modal-buttons">
          <button className="modal-button modal-button-submit" onClick={handleDenySubmit}>
            Submit
          </button>
          <button className="modal-button modal-button-cancel" onClick={closeModal}>
            Cancel
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default AdminLeaveTable;